<template>
    <ActionButton
      v-if="contacts_selection.emails_selected.count"
      text='contacts.actions.send_mail'
      @click="onActionToSendMail"
      icon='fas fa-pencil-alt'
      class="clear"
    />

    <ActionButton v-if="contacts_selection.count === 1 && contacts_selection.items[0].type === 'group'"
        @click='onRoute("/contacts/group/edit/" + contacts_selection.items[0].id)'
        text='contacts.actions.edit_group'
        icon='fas fa-user-edit group-edit'
        class="clear"
    />

    <ActionButton v-else-if="contacts_selection.count === 1 && contacts_selection.items[0].type === 'person'"
        @click='onRoute("/contacts/person/edit/" + contacts_selection.items[0].id)'
        text='contacts.actions.edit_person'
        icon='fas fa-user-edit'
        class="clear"
    />

    <ActionButton v-if="!contacts_selection.groups_count"
        text='contacts.actions.add_to_group'
        icon='fas fa-users'
        class="clear"
        @click="onSelectedContactsToGroup()"
    />

    <ActionButton
        v-if="contacts_selection.emails_selected.count"
        text='contacts.actions.add_filter'
        @click="onActionAddFilter"
        icon='fas fa-filter'
        class="clear"
    />

    <ActionButton
        text='contacts.actions.delete'
        icon='fas fa-trash-alt'
        class="clear"
       @click="onContactsDeleteOpen()"
    />

</template>

<script setup>
  import { defineProps } from 'vue';
  import ActionButton    from '@/vue/Elements/Buttons/ActionButton.vue';

  const props = defineProps({
    contacts_view      : {},
    contacts_selection : {},
    webmail_view       : {},
  })

  const onRoute = (route) => {
    props.webmail_view.routeTo(route);
  }

  const onSelectedContactsToGroup = () => {
    props.contacts_view.openContactsSelectedToGroup(props.contacts_selection);
  }

  const onContactsDeleteOpen = () => {
    props.contacts_view.openContactsDelete(props.contacts_selection);
  }

  const onActionAddFilter = () => {
    props.contacts_view.onActionAddFilter();
  }

  const onActionToSendMail = () => {
    const recipients = props.contacts_selection.getRecipients();
    props.contacts_view.onActionToSendMail(recipients);
  }
</script>
